"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFormHelp = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _FormHelpMixin = require("../../mixins/components/FormHelpMixin");
var StyledFormHelp = /*#__PURE__*/_styledComponents.default.p.withConfig({
  displayName: "StyledFormHelp",
  componentId: "c11n-8-107-0__sc-1rkt9zk-0"
})(["", ""], _FormHelpMixin.FormHelpMixin);
exports.StyledFormHelp = StyledFormHelp;